// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CanvasController from "./canvas_controller"
application.register("canvas", CanvasController)

import CardController from "./card_controller"
application.register("card", CardController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import DeviceController from "./device_controller"
application.register("device", DeviceController)

import DeviceFormController from "./device_form_controller"
application.register("device-form", DeviceFormController)

import DeviceIconController from "./device_icon_controller"
application.register("device-icon", DeviceIconController)

import DevicePlacementController from "./device_placement_controller"
application.register("device-placement", DevicePlacementController)

import DraggableCanvasController from "./draggable_canvas_controller"
application.register("draggable-canvas", DraggableCanvasController)

import DropdownInputController from "./dropdown_input_controller"
application.register("dropdown-input", DropdownInputController)

import WallEditorController from "./wall_editor_controller"
application.register("wall-editor", WallEditorController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import HeatmapController from "./heatmap_controller"
application.register("heatmap", HeatmapController)

import MoreFloorPlanController from "./more_floor_plan_controller"
application.register("more-floor-plan", MoreFloorPlanController)

import NumberInputController from "./number_input_controller"
application.register("number-input", NumberInputController)

import PasswordInputController from "./password_input_controller"
application.register("password-input", PasswordInputController)

import PlanController from "./plan_controller"
application.register("plan", PlanController)

import ProfileController from "./profile_controller"
application.register("profile", ProfileController)

import ScaleCanvasController from "./scale_canvas_controller"
application.register("scale-canvas", ScaleCanvasController)

import SearchInputController from "./search_input_controller"
application.register("search-input", SearchInputController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SimplifiedDropdownController from "./simplified_dropdown_controller"
application.register("simplified-dropdown", SimplifiedDropdownController)

import TabController from "./tab_controller"
application.register("tab", TabController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleEditController from "./toggle_edit_controller"
application.register("toggle-edit", ToggleEditController)

import BomEditorController from "./bom_editor_controller"
application.register("bom-editor", BomEditorController)

import TopologyEditorController from "./topology_editor_controller"
application.register("topology-editor", TopologyEditorController)

import ZoomController from "./zoom_controller"
application.register("zoom", ZoomController)

import UploadFilesController from "./upload_files_controller"
application.register("upload-files", UploadFilesController)
